import { Link, useMatch } from 'react-router-dom';

type TSidebarLinkProps = {
  id: string;
  to: string;
  children: ({ isActive }: { isActive: boolean }) => React.JSX.Element;
  classNames: {
    default: string;
    active: string;
  };
};

export function SidebarLink({ id, to, classNames, children }: TSidebarLinkProps) {
  const isActive = !!useMatch(to + '/*');

  return (
    <Link data-testid={id} className={isActive ? classNames.active : classNames.default} to={to}>
      {children({ isActive })}
    </Link>
  );
}
